import { ShoppingBag, User } from 'lucide-react';
import React from 'react';
import { TimelineStep } from './TimelineStep';
import './AtendimentoToReserva.css';
import { Alert } from 'react-bootstrap';

type Step = 'cliente' | 'reserva' | 'loading';

interface TimelineHorizontalProps {
    currentStep: Step;
    precisaCadastrarCliente: boolean;
}

export const TimelineHorizontal: React.FC<TimelineHorizontalProps> = ({
    currentStep,
    precisaCadastrarCliente,
}) => {
    const getClienteStatus = (): 'pending' | 'active' | 'completed' => {
        if (!precisaCadastrarCliente) return 'completed';
        if (currentStep === 'cliente') return 'active';
        if (currentStep === 'reserva') return 'completed';
        return 'pending';
    };

    const getReservaStatus = (): 'pending' | 'active' | 'completed' => {
        if (currentStep === 'cliente') return 'pending';
        if (currentStep === 'loading') return 'pending';
        if (currentStep === 'reserva') return 'active';
        return 'pending';
    };

    const isLineActive =
        currentStep === 'reserva' ||
        (!precisaCadastrarCliente && currentStep !== 'cliente');

    return (
        <>
            {/* TIMELINE */}
            <div className="timeline-horizontal">

                <TimelineStep
                    icon={User}
                    label="Cadastrar Cliente"
                    status={getClienteStatus()}
                />

                <div className={`timeline-line ${isLineActive ? 'active' : ''}`} />

                <TimelineStep
                    icon={ShoppingBag}
                    label="Criar Reserva"
                    status={getReservaStatus()}
                />
            </div>

            {/* MENSAGEM DE ALERTA */}
            {precisaCadastrarCliente && currentStep === 'cliente' && (
                <div className="timeline-warning-container">
                    <Alert variant="warning" className="mb-3">
                        Este cliente ainda não possui cadastro. Preencha os dados para continuar.
                    </Alert>
                </div>
            )}
        </>
    );
};
